<template>
    <div id="content">
        <div class="container-fluid mt-4">
            <!-- Top Stats Cards -->
            <div class="row mt-2 g-3">
                <div class="col-md-3 col-6">
                    <div class="card shadow-sm stats-card bg-lightblue">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-person-plus-fill stats-icon text-primary"></i>
                            <p class="mb-0 text-primary fw-semibold ms-2">New Leads</p>
                        </div>
                        <h3 class="fw-bold mt-2">{{ newLeads }}</h3>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="card shadow-sm stats-card bg-lightred">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-x-circle-fill stats-icon text-danger"></i>
                            <p class="mb-0 text-danger fw-semibold ms-2">Missed Leads</p>
                        </div>
                        <h3 class="fw-bold mt-2">{{ missedLeads }}</h3>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="card shadow-sm stats-card bg-lightgreen">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-calendar-check-fill stats-icon text-success"></i>
                            <p class="mb-0 text-success fw-semibold ms-2">Today's Visits</p>
                        </div>
                        <h3 class="fw-bold mt-2">{{ todaysVisits }}</h3>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="card shadow-sm stats-card bg-lightpurple">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-hourglass-split stats-icon text-purple"></i>
                            <p class="mb-0 text-purple fw-semibold ms-2">Pending</p>
                        </div>
                        <h3 class="fw-bold mt-2">{{ pending }}</h3>
                    </div>
                </div>
            </div>

            <!-- Active Leads Section -->
            <h4 class="mt-5 mb-3">Active Leads</h4>
            <div class="row g-3">
                <div class="col-md-6">
                    <div class="card p-3 shadow-sm position-relative">
                        <span class="badge bg-danger small-badge blink-badge">{{ activeLeadTimer1 }}</span>
                        <h5 class="mb-1">Rajesh Kumar</h5>
                        <p class="text-muted small">Knee</p>
                        <span class="badge bg-primary w-25">Open</span>
                        <p class="small mt-2">
                            <i class="fa fa-map-marker"></i> Indiranagar, Bangalore
                        </p>
                        <div class="d-flex gap-2 mt-3">
                            <button class="btn btn-primary w-100">Accept</button>
                            <button class="btn btn-danger w-100">Decline</button>
                            <button class="btn btn-success"><i class="fa fa-phone"></i></button>
                        </div>
                        <a href="#" class="small mt-2 text-primary">See Patient Details →</a>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="card p-3 shadow-sm position-relative">
                        <span class="badge bg-danger small-badge blink-badge">{{ activeLeadTimer2 }}</span>
                        <h5 class="mb-1">Anita Desai</h5>
                        <p class="text-muted small">Hip</p>
                        <span class="badge bg-success w-25">Open</span>
                        <p class="small mt-2">
                            <i class="fa fa-map-marker"></i> Koramangala, Bangalore
                        </p>
                        <div class="d-flex gap-2 mt-3">
                            <button class="btn btn-primary w-100">Accept</button>
                            <button class="btn btn-danger w-100">Decline</button>
                            <button class="btn btn-success"><i class="fa fa-phone"></i></button>
                        </div>
                        <a href="#" class="small mt-2 text-primary">See Patient Details →</a>
                    </div>
                </div>
            </div>

            <!-- Today's Schedule -->
            <h4 class="mt-5">Today's Schedule</h4>
            <div class="card shadow-sm p-3">
                <table class="table table-striped">
                    <thead class="table-dark">
                        <tr>
                            <th>Name</th>
                            <th>Last Interaction</th>
                            <th>Next Followup</th>
                            <th>Priority</th>
                            <th>Status</th>
                            <th>Follow Up</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b>Sneha Patel</b><br>
                                <small class="text-muted">1234567897</small>
                            </td>
                            <td><span class="badge bg-purple"><i class="fas fa-eye"></i> OPD Visit</span></td>
                            <td><span>OPD Visit</span><br />
                                <small class="text-muted">Today 2 Time</small>
                            </td>
                            <td><span>Low</span></td>
                            <td><span class="badge bg-warning">Xray Received <br /> (Opportunity)</span></td>
                            <td> <img :title="'No User'" alt="No User" style="height: 30px;" class="rounded-circle"
                                :src="'https://lead.kneexpert.in/files/adminc672b3.jpg'" /></td>
                            <td><i class="fa fa-edit" style="color: green;"></i></td>
                        </tr>
                        <tr>
                            <td>
                                <b>Rahul Mehta</b><br>
                                <small class="text-muted">1234345423</small>
                            </td>
                            <td><span class="badge bg-purple"><i class="fas fa-eye"></i> OPD Visit</span></td>
                            <td><span>OPD Visit</span><br />
                                <small class="text-muted">Today 2 Time</small>
                            </td>
                            <td><span>Low</span></td>
                            <td><span class="badge bg-warning">Xray Received <br /> (Opportunity)</span></td>
                            <td>

                                <img :title="'No User'" alt="No User" style="height: 30px;" class="rounded-circle"
                                    :src="'https://lead.kneexpert.in/files/adminc672b3.jpg'" />

                            </td>

                            <td><i class="fa fa-edit" style="color: green;"></i></td>
                        </tr>
                        <tr>
                            <td>
                                <b>Kavita Singh</b><br>
                                <small class="text-muted">1232343211</small>
                            </td>
                            <td><span class="badge bg-purple"><i class="fas fa-eye"></i> OPD Visit</span></td>
                            <td><span>OPD Visit</span><br />
                                <small class="text-muted">Today 2 Time</small>
                            </td>
                            <td><span>Low</span></td>
                            <td><span class="badge bg-warning">Xray Received <br /> (Opportunity)</span></td>
                            <td> <img :title="'No User'" alt="No User" style="height: 30px;" class="rounded-circle"
                                :src="'https://lead.kneexpert.in/files/adminc672b3.jpg'" /></td>
                            <td><i class="fa fa-edit" style="color: green;"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "DashboardPage",
    data() {
        return {
            newLeads: 12,
            missedLeads: 3,
            todaysVisits: 8,
            pending: 3,
            activeLeadSeconds1: 0, // Timer starts from 15:00
            activeLeadSeconds2: 0
        };
    },
    computed: {
        activeLeadTimer1() {
            return this.formatTime(900 + this.activeLeadSeconds1); // 900 sec = 15 min
        },
        activeLeadTimer2() {
            return this.formatTime(1500 + this.activeLeadSeconds2);
        }
    },
    mounted() {
        setInterval(() => {
            this.activeLeadSeconds1++;
            this.activeLeadSeconds2++;
        }, 1000); // Increase every second
    },
    methods: {
        formatTime(totalSeconds) {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        }
    }
};
</script>

<style scoped>
.bg-lightblue {
    background-color: #eff6ff;
}

.bg-lightred {
    background-color: #fef2f2;
}

.bg-lightgreen {
    background-color: #e7ffe7;
}

.bg-lightpurple {
    background-color: #f3e7ff;
}

/* Text colors */
.text-purple {
    color: #6f42c1;
}

.bg-purple {
    background-color: #6f42c1 !important;
}

/* Badge styling */
.small-badge {
    font-size: 12px;
    padding: 5px 8px;
    border-radius: 5px;
    position: absolute;
    top: 10px;
    right: 10px;
}

/* Stats Card Layout */
.stats-card {
    display: flex;
    padding: 15px;
    border-radius: 8px;
    border: none;
}

.stats-icon {
    font-size: 30px;
    margin-right: 15px;
}

/* Responsive Fix */
@media (max-width: 768px) {
    .row .col-md-3 {
        flex: 0 0 50%;
        max-width: 50%;
    }

    .row .col-lg-6 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .btn {
        font-size: 14px;
    }
}

/* Blinking Animation for Active Leads */
@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.blink-badge {
    animation: blink 1s infinite;
}

/* Responsive Fix */
@media (max-width: 768px) {
    .row .col-md-3 {
        flex: 0 0 50%;
        max-width: 50%;
    }

    .row .col-lg-6 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .btn {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/PhysioDashboard.vue